import { DemoVideoPlayer } from "./DemoVideoPlayer";

export const DemoPage = () => {
  return <DemoVideoPlayer />;
};
